export default __webpack_public_path__ + "static/media/restaurant-and-bars.d6f31642.svg";